<script>
  import Player from "../player.svelte";
  let episode = 1;
  function nextEpisode() {
    if (episode < 5) {
      episode += 1;
    }
  }
  function previousEpisode() {
    if (episode > 1) {
      episode -= 1;
    }
  }
</script>

{#if episode == 1}
  <Player id="A5-t5GIaw-Q" />

  <h2>Freedom - Episode 1</h2>
  <span>
    {#if episode > 1}
      <button on:click={previousEpisode}>&lt; Episode {episode - 1}</button>
    {/if}
    {#if episode < 5}
      <button on:click={nextEpisode}>Episode {episode + 1} &gt;</button>
    {/if}
  </span>
  <p>
    Sound editor - Rachael Hankin<br />
    Written and Edited by Grace Stokoe &amp; Megan Tarbuck
  </p>
  <p>
    Characters (In order of appearance):<br />
    Announcer (voiced by Hannah Roze-Lewis)<br />
    Girl 1 (voiced by Claire Beerjeraz)<br />
    May (voiced by Aleisha Mckenzie Jones)<br />
    Jenny (voiced by Amber Buttery)<br />
    Taylor (voiced by Hannah Roze-Lewis)<br />
    Beth (voiced by Claire Beerjeraz)<br />
    Deano (voiced by Callum Sheridan-Lee)<br />
    Freddie (voiced by Louis Saxby)
  </p>
{/if}
{#if episode == 2}
  <Player id="Ckj2UUi8ntw" />
  <h2>Freedom - Episode 2</h2>
  <span>
    {#if episode > 1}
      <button on:click={previousEpisode}>&lt; Episode {episode - 1}</button>
    {/if}
    {#if episode < 5}
      <button on:click={nextEpisode}>Episode {episode + 1} &gt;</button>
    {/if}
  </span>
  <p>
    Sound editor - Rachael Hankin<br />
    Written and Edited by Grace Stokoe &amp; Megan Tarbuck
  </p>
  <p>
    Characters (In order of appearance):<br />
    Man (voiced by Luke Cashmore)<br />
    Girl 1 (voiced by Claire Beerjeraz)<br />
    Girl 2 (voiced by Hannah Roze-Lewis)<br />
    Girl 3 (voiced by Aleisha Mckenzie Jones)<br />
    Announcer (voiced by Hannah Roze-Lewis)<br />
    May (voiced by Aleisha Mckenzie Jones)<br />
    Mikayla (voiced by Amber Buttery)<br />
    Taylor (voiced by Hannah Roze-Lewis)<br />
    Beth (voiced by Claire Beerjeraz)<br />
    Chantelle (voiced by Aleisha Mckenzie Jones)<br />
    Manager (voiced by Claire Beerjeraz)<br />
    Freddie (voiced by Louis Saxby)<br />
    Deano (voiced by Callum Sheridan-Lee)<br />
    Jenny (voiced by Amber Buttery)<br />
    Shopper (voiced by Aleisha Mckenzie Jones)
  </p>
{/if}
{#if episode == 3}
  <Player id="xdPsFQtv478" />
  <h2>Freedom - Episode 3</h2>
  <span>
    {#if episode > 1}
      <button on:click={previousEpisode}>&lt; Episode {episode - 1}</button>
    {/if}
    {#if episode < 5}
      <button on:click={nextEpisode}>Episode {episode + 1} &gt;</button>
    {/if}
  </span>
  <p>
    Sound editor - Rachael Hankin<br />
    Written and Edited by Grace Stokoe &amp; Megan Tarbuck
  </p>
  <p>
    Characters (In order of appearance):<br />
    Girl 3 (voiced by Aleisha Mckenzie Jones)<br />
    Girl 1 (voiced by Claire Beerjeraz)<br />
    Girl 4 (voiced by Amber Buttery)<br />
    Announcer (voiced by Hannah Roze-Lewis)<br />
    May (voiced by Aleisha Mckenzie Jones)<br />
    Mikayla (voiced by Amber Buttery)<br />
    Chantelle (voiced by Aleisha Mckenzie Jones)<br />
    Taylor (voiced by Hannah Roze-Lewis)<br />
    Beth (voiced by Claire Beerjeraz)<br />
    Jenny (voiced by Amber Buttery)<br />
    Shopper (voiced by Aleisha Mckenzie Jones)<br />
    Deano (voiced by Callum Sheridan-Lee)<br />
    Freddie (voiced by Louis Saxby)<br />
    Manager (voiced by Claire Beerjeraz)
  </p>
{/if}
{#if episode == 4}
  <Player id="2O5phJ8uFyA" />
  <h2>Freedom - Episode 4</h2>
  <span>
    {#if episode > 1}
      <button on:click={previousEpisode}>&lt; Episode {episode - 1}</button>
    {/if}
    {#if episode < 5}
      <button on:click={nextEpisode}>Episode {episode + 1} &gt;</button>
    {/if}
  </span>
  <p>
    Sound editor - Rachael Hankin<br />
    Written and Edited by Grace Stokoe &amp; Megan Tarbuck
  </p>
  <p>
    Characters (In order of appearance):<br />
    Girl 1 (voiced by Claire Beerjeraz)<br />
    Girl 4 (voiced by Amber Buttery)<br />
    Girl 3 (voiced by Aleisha Mckenzie Jones)<br />
    Announcer (voiced by Hannah Roze-Lewis)<br />
    May (voiced by Aleisha Mckenzie Jones)<br />
    Taylor (voiced by Hannah Roze-Lewis)<br />
    Mikayla (voiced by Amber Buttery)<br />
    Chantelle (voiced by Aleisha Mckenzie Jones)<br />
    Beth (voiced by Claire Beerjeraz)<br />
    Ramona (voiced by Hannah Roze-Lewis)<br />
    Manager (voiced by Claire Beerjeraz)<br />
    Deano (voiced by Callum Sheridan-Lee)<br />
    Freddie (voiced by Louis Saxby)<br />
    Jenny (voiced by Amber Buttery)
  </p>
{/if}
{#if episode == 5}
  <Player id="pEI69rBjH6A" />
  <h2>Freedom - Episode 5</h2>
  <span>
    {#if episode > 1}
      <button on:click={previousEpisode}>&lt; Episode {episode - 1}</button>
    {/if}
    {#if episode < 5}
      <button on:click={nextEpisode}>Episode {episode + 1} &gt;</button>
    {/if}
  </span>
  <p>
    Sound editor - Rachael Hankin<br />
    Written and Edited by Grace Stokoe &amp; Megan Tarbuck
  </p>
  <p>
    Characters (In order of appearance):<br />
    Man (voiced by Luke Cashmore)<br />
    Girl 1 (voiced by Claire Beerjeraz)<br />
    Girl 4 (voiced by Amber Buttery)<br />
    Girl 3 (voiced by Aleisha Mckenzie Jones)<br />
    Announcer (voiced by Hannah Roze-Lewis)<br />
    Manager (voiced by Claire Beerjeraz)<br />
    Deano (voiced by Callum Sheridan-Lee)<br />
    Freddie (voiced by Louis Saxby)<br />
    Customer (voiced by Duncan Riches)<br />
    Taylor (voiced by Hannah Roze-Lewis)<br />
    Chantelle (voiced by Aleisha Mckenzie Jones)<br />
    Beth (voiced by Claire Beerjeraz)<br />
    Mikayla (voiced by Amber Buttery)<br />
    Jenny (voiced by Amber Buttery)<br />
    May (voiced by Aleisha Mckenzie Jones)
  </p>
{/if}

<style>
  button {
    padding: 8px;
    margin: 0 8px;
    border-radius: 0;
    background-color: transparent;
    color: #fff;
    border: 2px solid #b2dee5;
  }
  button:hover {
    background-color: rgba(0, 0, 0, 0.3);
  }
</style>
